module.exports = __webpack_public_path__ + "img/feiyi.cd403ed3.png";